export default __webpack_public_path__ + "static/media/study.81a54908.png";